import { useQuery } from '@tanstack/react-query';

import { fetchPrescription } from '../api/getPrescription.js';
import { rxKeys } from './keys.js';

export function prescriptionQueryDefinition(userId: string, dosespotPrescriptionId: string) {
  return {
    queryKey: rxKeys.prescription(userId, dosespotPrescriptionId),
    queryFn: ({ signal }: { signal?: AbortSignal }) =>
      fetchPrescription(userId, dosespotPrescriptionId, signal),
    meta: {
      toast: {
        title: 'Could not load prescription',
        description: 'Prescription could not be fetched from DoseSpot.',
      },
    },
  } as const;
}

export function usePrescriptionQuery(userId: string | undefined, dosespotPrescriptionId: string) {
  return useQuery({
    ...prescriptionQueryDefinition(userId ?? '', dosespotPrescriptionId),
    enabled: !!userId && dosespotPrescriptionId.trim() !== '',
  });
}
